module.exports = __webpack_public_path__ + "img/yass-express-logo.3abb40cb.png";